import React from 'react'
import { useCallback, useEffect, useState } from 'sb-hooks'


const checkIsChild = (node, targetNode) => {
  if (!node) {
    return false
  }

  if (node === targetNode) {
    return true
  }

  return checkIsChild(node.parentNode, targetNode)
}


const useToggleOpen = (props = {}) => {
  const { initialValue, targetNodeRef, toggleOnWindowClick } = props

  const [ isOpened, setOpened ] = useState(Boolean(initialValue))

  const open    = useCallback(() => setOpened(true), [])
  const close   = useCallback(() => setOpened(false), [])
  const toggle  = useCallback(() => setOpened(!isOpened), [ isOpened ])

  const closeHandler = useCallback((event) => {
    const isChild = checkIsChild(event.target, targetNodeRef.current)

    if (!isChild) {
      close()
    }
  }, [ targetNodeRef ])

  useEffect(() => {
    if (toggleOnWindowClick) {
      if (isOpened) {
        window.addEventListener('click', closeHandler)
      }
      else {
        window.removeEventListener('click', closeHandler)
      }
    }
  }, [ isOpened, toggleOnWindowClick, closeHandler ])

  return {
    isOpened,
    open,
    close,
    toggle,
  }
}


export default useToggleOpen
